import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { environment } from "../../environments/environments";
// import "./ConnectionPayment.css";
import "../ConnectionPayment/ConnectionPayment.css";
import { connectionFeeList } from "../api/api";

const ConnectionPayment = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState([]);

  useEffect(() => {
    const fetchPaymentDetails = async () => {
      setLoading(true);
      try {
        const response = await connectionFeeList();
        console.log("Plans List:", response?.plans);
        setPaymentDetails(response?.plans || []);
      } catch (error) {
        console.error("Error fetching plans:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentDetails();
  }, []);

  const handlePlanPayment = (plan) => {
    const userData = localStorage.getItem("currentUser");
    const parsedUserData = JSON.parse(userData);
    const userId = parsedUserData?.id || parsedUserData?._id;
    const url = `https://backend.connecttovow.com/kfdsgkhdksfhskufhdkfjhkugh4778vbkjhdvsjhdvjkshgdvwukdvbkjhb/${plan?.id}/${userId}`;
    // window.open(url, "_blank");
    navigate("/Sidebar/ConnectionPaymentWebView", {
      state: { paymentUrl: url },
    });
  };

  return (
    <div className="connection-payment-container">
      <div className="payment-header">
        <h2>Secure Payment</h2>
        <span role="img" aria-label="lock">
          🔒
        </span>
      </div>

      <h3 className="title">Choose Your Connection Plan</h3>
      <p className="description">
        Pay the one-time connection fee to start interacting with other users.
      </p>

      {loading ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="plans-wrapper">
          {paymentDetails.map((plan) => (
            <div className="plan-card" key={plan.id}>
              <h4 className="plan-name">{plan.name}</h4>
              <p className="plan-price">
                {plan.currency_symbol} {plan.price}
              </p>
              <button
                className="pay-button"
                onClick={() => handlePlanPayment(plan)}
              >
                Pay Now
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ConnectionPayment;
